import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedDocumentTypeSelector($companyId: ID!, $id: ID) {
    documentTypes(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        name
      }
    }
  }
`

export const Query = gql`
  query DocumentTypeSelector(
    $companyId: ID!,
    $documentTypeFilters: DocumentTypeFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    documentTypes(
      companyId: $companyId,
      filters: $documentTypeFilters,
      after: $after,
      before: $before,
      first: $first,
      last: $last
    ) {
      nodes {
        id
        name
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
